module.exports = __webpack_public_path__ + "static/media/whiteRabbit.0165661a.jpg";